import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import ExpandDiv from "./common/ExpandDiv";
// import rules from "../json/PCRs.json";
import Select from "./common/Select";
import Input from "./common/Input";
import { billingRules, getBillingPayors } from "./services/soar";

function CensusRulesEngine(props) {
  const location = useLocation();
  const qs = queryString.parse(location.search);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const [rules, setRules] = useState([]);
  // const payors = [...new Set(rules.map((item) => item.PAYOR))];
  const [payors, setPayors] = useState([]);
  const [data, setData] = useState({
    payor: qs.Payor ? qs.Payor : "",
    groupName: qs.GroupName ? qs.GroupName : "",
    modality: qs.Modality ? qs.Modality : "",
    serviceItem: qs.ServiceItem ? qs.ServiceItem : "",
    serviceStatus: qs.ServiceStatus ? qs.ServiceStatus : "",
    age: qs.Age ? qs.Age : "",
    date: qs.Date ? qs.Date : "",
    status: "All",
  });

  const [selectedRule, setSelectedRule] = useState();

  const [newRule, setNewRule] = useState({
    payor: "",
    groupName: "",
    modality: "",
    serviceItem: "",
    serviceStatus: "",
    ageMin: "",
    ageMax: "",
    effDate: "",
    endDate: "",
    rate: "",
    expected: "",
    billingForm: "",
    programCostCenter: "",
    type: "",
  });
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (safyInfo.user.modules.includes("Admin")) {
      getBillingPayors().then((res) => {
        console.log("payors", res);
        const payors = res.data.map((item) => item.Payor);
        setPayors(payors);
      });
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (data.payor && data.payor !== "") {
      const body = { payor: data.payor };

      billingRules(body).then((res) => {
        console.log("res", res);
        // const resPayors = [...new Set(res.data.map((item) => item.Payor))];
        // console.log("resPayors", resPayors);
        setRules(res.data);
        // setPayors(resPayors);
      });
    }
  }, [data.payor]);

  const toggleModal = () => {
    setNewRule({
      payor: isOpen ? "" : data.payor,
      groupName: isOpen ? "" : data.groupName,
      modality: isOpen ? "" : data.modality,
      serviceItem: isOpen ? "" : data.serviceItem,
      serviceStatus: isOpen ? "" : data.serviceStatus,
      ageMin: "",
      ageMax: "",
      effDate: "",
      endDate: "",
      rate: "",
      expected: "",
      billingForm: "",
      programCostCenter: "",
      contract: "",
      id: "",
      type: "new",
    });
    setIsOpen(!isOpen);
  };

  const editExistingRule = (rule) => {
    setNewRule({
      payor: rule.Payor,
      groupName: rule.GroupPayor,
      modality: rule.Modality,
      serviceItem: rule.ServiceItem,
      serviceStatus: rule.ServiceStatus,
      ageMin: rule.AgeMin,
      ageMax: rule.AgeMax,
      effDate: "",
      endDate: "",
      rate: rule.Rate,
      expected: rule.Expected,
      billingForm: rule.BillingForm,
      programCostCenter: rule.ProgramCostCenter,
      contractId: rule.ContractId,
      id: rule.ID,
      type: "edit",
    });
    setIsOpen(!isOpen);
  };

  const setDataValue = (att, value) => {
    let obj = { ...data };
    obj[att] = value;
    setData(obj);
  };

  const setNewRuleValue = (att, value) => {
    let obj = { ...newRule };
    obj[att] = value;
    console.log("obj", obj);
    setNewRule(obj);
  };

  const filterRules = () => {
    let filtered = rules;
    if (data.payor) {
      filtered = filtered.filter((item) => item.Payor === data.payor);
    }
    if (data.groupName) {
      filtered = filtered.filter((item) => item.GroupPayor === data.groupName);
    }
    if (data.modality) {
      filtered = filtered.filter((item) => item.Modality === data.modality);
    }
    if (data.serviceItem) {
      filtered = filtered.filter(
        (item) => item.ServiceItem === data.serviceItem
      );
    }
    if (data.serviceStatus) {
      filtered = filtered.filter(
        (item) => item.ServiceStatus === data.serviceStatus
      );
    }
    if (data.age && data.age !== "") {
      filtered = filtered.filter(
        (item) => item.AgeMin <= data.age && item.AgeMax >= data.age
      );
    }
    if (data.date && data.date !== "") {
      filtered = filtered.filter(
        (item) =>
          new Date(item.EffectiveDate) <= new Date(data.date) &&
          (!item.ExpirationDate ||
            new Date(item.ExpirationDate) >= new Date(data.date))
      );
    }

    if (data.status === "Active") {
      filtered = filtered.filter(
        (item) =>
          !item.ExpirationDate || new Date(item.ExpirationDate) > new Date()
      );
    }
    if (data.status === "Inactive") {
      filtered = filtered.filter(
        (item) =>
          item.ExpirationDate && new Date(item.ExpirationDate) < new Date()
      );
    }
    return filtered;
  };

  return (
    <div>
      <Modal
        show={isOpen}
        animation={false}
        onHide={() => {
          toggleModal();
        }}
        size="lg"
      >
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Add Census Rule</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {newRule.type === "edit" ? (
            <div className="bg-danger text-white p-2 rounded h5">
              Creating this rule will automatically expire the existing rule
            </div>
          ) : null}
          <Input
            label="Payor"
            value={newRule.payor}
            onChange={(e) => setNewRuleValue("payor", e.currentTarget.value)}
          />
          <div className="row">
            <div className="col">
              <Input
                label="Group Name"
                value={newRule.groupName}
                onChange={(e) =>
                  setNewRuleValue("groupName", e.currentTarget.value)
                }
              />
            </div>
            <div className="col">
              <Input
                label="Modality"
                value={newRule.modality}
                onChange={(e) =>
                  setNewRuleValue("modality", e.currentTarget.value)
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Service Item"
                value={newRule.serviceItem}
                onChange={(e) =>
                  setNewRuleValue("serviceItem", e.currentTarget.value)
                }
              />
            </div>
            <div className="col">
              <Input
                label="Service Status"
                value={newRule.serviceStatus}
                onChange={(e) =>
                  setNewRuleValue("serviceStatus", e.currentTarget.value)
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Age Min"
                value={newRule.ageMin}
                onChange={(e) =>
                  setNewRuleValue("ageMin", e.currentTarget.value)
                }
              />
            </div>
            <div className="col">
              <Input
                label="Age Max"
                value={newRule.ageMax}
                onChange={(e) =>
                  setNewRuleValue("ageMax", e.currentTarget.value)
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Effective Date"
                value={newRule.effDate}
                onChange={(e) =>
                  setNewRuleValue("effDate", e.currentTarget.value)
                }
              />
            </div>
            <div className="col">
              <Input
                label="End Date"
                value={newRule.endDate}
                onChange={(e) =>
                  setNewRuleValue("endDate", e.currentTarget.value)
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Rate"
                value={newRule.rate}
                onChange={(e) => setNewRuleValue("rate", e.currentTarget.value)}
              />
            </div>
            <div className="col">
              <Input
                label="Expected"
                value={newRule.expected}
                onChange={(e) =>
                  setNewRuleValue("expected", e.currentTarget.value)
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Billing Form"
                value={newRule.billingForm}
                onChange={(e) =>
                  setNewRuleValue("billingForm", e.currentTarget.value)
                }
              />
            </div>
            <div className="col">
              <Input
                label="Program Cost Center"
                value={newRule.programCostCenter}
                onChange={(e) =>
                  setNewRuleValue("programCostCenter", e.currentTarget.value)
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="ID"
                value={newRule.id}
                onChange={(e) =>
                  setNewRuleValue("contract", e.currentTarget.value)
                }
              />
            </div>
            <div className="col">
              <Input
                label="Contract ID"
                value={newRule.contractId}
                onChange={(e) =>
                  setNewRuleValue("contractId", e.currentTarget.value)
                }
              />
            </div>
          </div>

          <div className="row">
            <div className="col">
              <button
                className="btn btn-primary float-end"
                onClick={() => {
                  toast.success(
                    "This would have added a new rule to the database"
                  );
                  toggleModal();
                }}
              >
                Add Rule
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div className="row">
        <div className="col-10">
          <Select
            label="Payor"
            options={payors
              .map((item) => ({ name: item, _id: item }))
              .sort((a, b) => a.name.localeCompare(b.name))}
            value={data.payor}
            onChange={(e) => {
              setDataValue("payor", e.currentTarget.value);
              setSelectedRule(null);
            }}
          />
        </div>
        <div className="col-2 pt-2">
          <button
            className="btn btn-danger mt-4 float-end"
            onClick={() => {
              setData({
                payor: "",
                groupName: "",
                modality: "",
                serviceItem: "",
                serviceStatus: "",
                age: "",
                date: "",
                status: "All",
              });
            }}
          >
            Clear
          </button>
        </div>
      </div>
      {data.payor ? (
        <>
          <div className="row">
            <div className="col">
              <Select
                label="Group Name"
                options={[
                  ...new Set(
                    rules
                      .filter((item) => item.Payor === data.payor)
                      .map((item) => item.GroupPayor)
                  ),
                ].map((item) => ({ name: item, _id: item }))}
                value={data.groupName}
                onChange={(e) => {
                  setDataValue("groupName", e.currentTarget.value);
                  setSelectedRule(null);
                }}
              />
            </div>
            <div className="col">
              <Select
                label="Modality"
                options={[
                  ...new Set(
                    rules
                      .filter((item) => item.Payor === data.payor)
                      .map((item) => item.Modality)
                  ),
                ].map((item) => ({ name: item, _id: item }))}
                value={data.modality}
                onChange={(e) => {
                  setDataValue("modality", e.currentTarget.value);
                  setSelectedRule(null);
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Select
                label="Service Item"
                options={[
                  ...new Set(
                    rules
                      .filter((item) => item.Payor === data.payor)
                      .map((item) => item.ServiceItem)
                  ),
                ].map((item) => ({ name: item, _id: item }))}
                value={data.serviceItem}
                onChange={(e) => {
                  setDataValue("serviceItem", e.currentTarget.value);
                  setSelectedRule(null);
                }}
              />
            </div>
            <div className="col">
              <Select
                label="Service Status"
                options={[
                  ...new Set(
                    rules
                      .filter((item) => item.Payor === data.payor)
                      .map((item) => item.ServiceStatus)
                  ),
                ].map((item) => ({ name: item, _id: item }))}
                value={data.serviceStatus}
                onChange={(e) => {
                  setDataValue("serviceStatus", e.currentTarget.value);
                  setSelectedRule(null);
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Input
                label="Age"
                value={data.age}
                onChange={(e) => {
                  setDataValue("age", e.currentTarget.value);
                  setSelectedRule(null);
                }}
              />
            </div>
            <div className="col">
              <Input
                type="date"
                label="Date"
                value={data.date}
                onChange={(e) => {
                  setDataValue("date", e.currentTarget.value);
                  setSelectedRule(null);
                }}
              />
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-6">
              <Select
                label="Status"
                options={[
                  { name: "All", _id: "All" },
                  { name: "Active", _id: "Active" },
                  { name: "Inactive", _id: "Inactive" },
                ]}
                value={data.status}
                onChange={(e) => {
                  setDataValue("status", e.currentTarget.value);
                  setSelectedRule(null);
                }}
              />
            </div>
            <div className="col-6 pt-4">
              <div
                className="btn btn-primary float-end mt-2"
                onClick={() => {
                  toggleModal();
                }}
              >
                Add Rule from Selected Options
              </div>
            </div>
          </div>
        </>
      ) : null}
      <div className="row m-1 h5">
        <div className="col-2">Group Name</div>
        <div className="col-2">Modality</div>
        <div className="col-2">Service Item</div>
        <div className="col-2">Service Status</div>
        <div className="col-1">Ages</div>
        <div className="col-1">Dates</div>
        <div className="col-1">Rate</div>
        <div className="col-1"></div>
      </div>
      {data.payor ? (
        filterRules().map((item, index) => (
          <>
            <div
              title={item.RuleId}
              key={`rule${index}`}
              className={
                item.ExpirationDate &&
                new Date(item.ExpirationDate) < new Date()
                  ? "row rounded border border-danger m-1 bg-light p-1"
                  : "row rounded border border-success m-1 bg-light p-1"
              }
            >
              <div className="col-2">{item.GroupPayor}</div>
              <div className="col-2">{item.Modality}</div>
              <div className="col-2">{item.ServiceItem}</div>
              <div className="col-2">{item.ServiceStatus}</div>
              <div className="col-1">{`${item.AgeMin}-${item.AgeMax}`}</div>

              <div className="col-1">
                {item.ExpirationDate &&
                new Date(item.ExpirationDate) < new Date()
                  ? `Expired ${item.ExpirationDate}`
                  : `Effective ${item.EffectiveDate}`}
              </div>
              <div className="col-1">{item.Rate}</div>
              <div className="col-1">
                <i
                  className="fas fa-circle-info text-primary"
                  onClick={() => setSelectedRule(index)}
                ></i>
              </div>
            </div>
            {selectedRule === index ? (
              <div className="border rounded bg-warning p-2">
                <button
                  className="btn btn-danger float-end m-2"
                  onClick={() => setSelectedRule(null)}
                >
                  Close
                </button>
                <button
                  className="btn btn-primary float-end m-2"
                  onClick={() => editExistingRule(item)}
                >
                  Create from existing
                </button>
                <p className="ms-4 h6">RATE: {item.Rate}</p>
                <p className="ms-4 h6">EXPECTED: {item.Expected}</p>
                <p className="ms-4 h6">EFF_DATE: {item.EffectiveDate}</p>
                <p className="ms-4 h6">EXP_DATE: {item.ExpirationDate}</p>
                <p className="ms-4 h6">CONTRACT_ID: {item.ContractId}</p>
                <p className="ms-4 h6">ID: {item.Id}</p>
                <p className="ms-4 h6">
                  REVENUE_BOOKED_AS: {item.RevenueBookedAs}
                </p>
                <p className="ms-4 h6">SERIES_BILLING: {item.SeriesBilling}</p>
                <p className="ms-4 h6">PRICE_PER: {item.PricePer}</p>
                <p className="ms-4 h6">FULL_NAME: {item.FullName}</p>
                <p className="ms-4 h6">FULL_NAME_2: {item.FullName2}</p>
                <p className="ms-4 h6">FULL_NAME_3: {item.FullName3}</p>
                <p className="ms-4 h6">BILLING_FORM: {item.BillingForm}</p>
                <p className="ms-4 h6">
                  PROGRAM_COST_CENTER: {item.ProgramCostCenter}
                </p>
                <p className="ms-4 h6">PAYOR: {item.TreatmentModality}</p>
              </div>
            ) : null}
          </>
        ))
      ) : (
        <div className="h5 text-primary m-4">
          Please select a payor to see rules
        </div>
      )}
    </div>
  );
}

export default CensusRulesEngine;
